import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { FaLightbulb } from "react-icons/fa";
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { HiLink } from 'react-icons/hi';
import { FaChartLine } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  Textarea,
  Input,
  Divider,
  Tooltip,
} from '@chakra-ui/react';
import Select from 'react-select';
import {
  MdAdd,
  MdCloudUpload,
  MdInbox,
  MdNote,
  MdNoteAdd,
  MdTextsms,
  MdDelete,
  MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';

import StrightConector from '../components/dragNdrop/strightConector';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import { FaAward } from 'react-icons/fa6';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
//yash code
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';

interface PropsNote {
  formData?: any;
  reviews?: any;
  id?: number;
  language?: any;
  seq?: any;
  index?: number;
  handleNDI?: any;
  name?: any;
  handleInput?: any;
  input?: any;
  getSeq?: any;
  handleMiniNDI?: any;
  duplicateSeq?: any;
  delSeq?: any;
  alphabet?: any;
  setNavigation: any;
  handleBlock: any;
  items?: any;
  formDataGamelanguageCode?: any;
  handleSelectBlock?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  currentseq?: any;
  ShowReview?: any;
  showReflectionQuestions:any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
}
interface Block {
  blockPrimarySequence: string;
  // Add other properties as needed
  content: string | undefined; // Adjust the type according to your data structure
}
const OverviewCompo: React.FC<PropsNote> = ({
  formData,
  targetSequence,
showReflectionQuestions,
  seq,
  index,
  name,
  handleInput,
  input,
  getSeq,
  duplicateSeq,
  delSeq,

  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,

  showSelectBlock,
  handleNDI,

  validation,
}) => {
  // const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.data?.id;


    console.log("Login user id:", userId);

    if (userId) {
      // First get user details including company ID
      getCreator(userId)
        .then(userResult => {
          console.log('Complete login user data:', userResult);

          if (userResult?.data?.ctCompanyId) {
            const companyId = userResult.data.ctCompanyId;
            console.log('User company ID:', companyId);

            // Now fetch company details using company ID
            return getCompany(companyId)
              .then(companyResult => {
                console.log('Company details:', companyResult);

                // Get company name - data is an array, so use [0]
                const companyName = companyResult?.data?.[0]?.cpCompanyName;

                console.log('User belongs to company:', companyName);

                // Now you can use companyName for your logic
                if (companyName?.toLowerCase() === 'cognizant' || 'CTS') {
                  // setshowScenarioCompletion(true);

                } else {
                  // setshowScenarioCompletion(false);
                }
              });
          } else {
            console.log('User has no company ID');
            // setshowScenarioCompletion(false);
          }
        })
        .catch(error => {
          console.error('Error fetching user or company details:', error);
          // setshowScenarioCompletion(false);
        });
    }
  }, []);

  const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
    label: `Scenario ${i + 1}`,
    value: `Scenario ${i + 1}`,
  }));

  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input?.[`Overview${seq.input}`]?.Overview]);

  const customButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    borderColor: '#ccc', // Optional: Change border color for disabled state
    borderWidth: '1px', // Add this line to set the border width
    borderStyle: 'solid', // Add this line to set the border style
    cursor: 'not-allowed', // Optional: Change cursor for disabled state
    padding: '5px 10px',
    width: '144px',
    // textAlign: "left",
    outerWidth: '10px',
    outline: 'none',
  };

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '130px',
      padding: '0 !important',
    }),
  };

  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);

    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value !== '') {
      handleSelectBlock(
        { value: input },
        input,
        `Overview${seq.input}`,
        `Overview${seq.input}`,
      );
    }
  };
  const MiniBox1 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {

    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Note', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                   Note
                 </ListItem>
       
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                   Dialog
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                 >
                   <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                   Interaction
                 </ListItem>
                 <ListItem
                   onClick={() => handleMiniNDInewblock('Link', seq, i)}
                   p={'10px'}
                   display={'flex'}
                   alignItems={'center'}
                   borderBottom={'2px solid #f1f1f170'}
                 >
                   <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                   Link
                 </ListItem>
                 {showReflectionQuestions && (
                   <>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                       Reflection
                     </ListItem>
       
                     <ListItem
                       onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                       Overview
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                       KeyInsights
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                       PreAssessment
                     </ListItem>
                     <ListItem
                       onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                       p={'10px'}
                       display={'flex'}
                       alignItems={'center'}
                       borderBottom={'2px solid #f1f1f170'}
                     >
                       <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                       PostAssessment
                     </ListItem>
                                    <ListItem
                                 onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                                 p={'10px'}
                                 display={'flex'}
                                 alignItems={'center'}
                                 borderBottom={'2px solid #f1f1f170'}
                               >
                                 <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                                 WehaveChoose
                               </ListItem>
                                          <ListItem
                                 onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                                 p={'10px'}
                                 display={'flex'}
                                 alignItems={'center'}
                                 borderBottom={'2px solid #f1f1f170'}
                               >
                                 <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                                 Swipe
                               </ListItem>
                                          <ListItem
                                 onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                                 p={'10px'}
                                 display={'flex'}
                                 alignItems={'center'}
                                 borderBottom={'2px solid #f1f1f170'}
                               >
                                 <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                                 Drag For Now 
                               </ListItem>
                   </>
                 )}
                 {formData?.gameScenarioCompletion === 'true' && (
                   <ListItem
                     onClick={() =>
                       handleMiniNDInewblock('ScenarioCompletion', seq, i)
                     }
                     p={'10px'}
                     display={'flex'}
                     alignItems={'center'}
                     borderBottom={'2px solid #f1f1f170'}
                   >
                     <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                     ScenarioCompletion
                   </ListItem>
                 )}
               </List>
      </Box>
    );
  };

  let focusSeqRef: any;
  const justClick = (event: any, seq: any) => {
    if (event.type === 'click') {
      focusSeqRef = document.getElementsByClassName(seq.id);
      const element = focusSeqRef?.[0];

      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };

  return (
    <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
      <Box className="block-action-icons">
        <Tooltip hasArrow label="Choose New Block">
          <div>
            <Icon
              as={MdAdd}
              transitionDelay={'0s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() => getSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Duplicate">
          <div>
            <Icon
              as={BiSolidDuplicate}
              transitionDelay={'0.1s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() =>
                duplicateSeq(seq, index, name, input?.[`Overview${seq.input}`])
              }
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Delete Overview">
          <div>
            <Icon
              as={MdDelete}
              transitionDelay={'0.2s !important'}
              fontSize={'18px'}
              color={'grey'}
              cursor={'pointer'}
              onClick={() => delSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
      </Box>
      <Box
        className="block-id"
        mr={'10px'}
        w={'50px'}
        fontSize={'17px'}
        color={'#1b2559'}
        fontWeight={'700'}
      >
        {seq.id}
      </Box>
      <Box
        className="box-block"
        w={{ base: '100%', lg: 'auto' }}
        flexDirection={{ base: 'column', lg: 'row' }}
        display={'flex'}
        alignItems={'center'}
      >
        <Box
          className="block-input-text"
          mr={'10px'}
          mb={{ base: '10px', lg: '0px' }}
          w={{ base: '100%', lg: '400px' }}
        >
          <Textarea
            ref={textareaRef}
            placeholder="Overview "
            id="Overview"
            className={`${seq.id}`}
            name={`Overview${seq.input}`}
            onChange={handleInput}
            onClick={(e) => justClick(e, seq)}
            value={input?.[`Overview${seq.input}`]?.Overview || ''}
            isRequired={true}
            minHeight="65px"
            height={seq?.id === targetSequence?.id ? 'auto' : '65px !important'}
            borderRadius={'18px'}
            style={{
              overflow: 'hidden',
              border: validation?.[`Overview${seq.input}`] && '2px solid red',
            }}
            overflow="auto" // Allow vertical scrolling
            _focusVisible={{
              borderColor: '#0000',
              border: '1px solid #e5e5e5',
              boxShadow: 'unset',
            }}
            tabIndex={0}
            readOnly={true}
          />
        </Box>

        <Box
          className="scenario-dropdown"
          mb="10px"
          w={{ base: '100%', lg: '200px' }}
        >
          <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
            Select Scenario
          </Text>

          <Select
            placeholder="Select Scenario"
            options={scenarioOptions}
            // value={input?.[`Note${seq.input}`]?.scenario || null}

            value={
              scenarioOptions.find(
                (opt) =>
                  opt.value === input?.[`Overview${seq.input}`]?.scenario
              ) || null
            }
            styles={{
              ...customStyles,
              control: (provided: any) => ({
                ...provided,
                borderRadius: '12px',
                minHeight: '36px',
              }),
            }}
            onChange={(option: any) =>
              handleInput({
                name: `Overview${seq.input}`,
                value: {
                  // scenario: option,
                  scenario: option?.value,

                },
              })
            }
            isSearchable={false}
            menuPortalTarget={document.body}
          />
        </Box>
        <Box
          className="navigation-icon"
          h={'100%'}
          display={'flex'}
          alignItems={'center'}
          mr={'40px'}
          width={'auto'}
        >
          <Flex>
            <Box>
              <Tooltip hasArrow label="Add Navigations">
                <div>
                  <Menu
                    tabState={'leadDialog'}
                    id={seq.input}
                    for={`Overview${seq.input}`}
                    setNavigation={setNavigation}
                    handleBlock={handleBlock}
                    items={items}
                    seq={seq}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box
              ml={'4px'}
              cursor={'pointer'}
              display={
                input?.[`Overview${seq.input}`]?.OverviewleadShow ? 'block' : 'none'
              }
              zIndex={9999}
            >
              {input?.[`Overview${seq.input}`]?.OverviewleadShow === 'New Block' &&
                !input?.[`Overview${seq.input}`]?.Overviewnavigate ? (
                // Render content for New Block
                <>
                  <MiniBox1 seq={seq} i={index} />
                </>
              ) : input?.[`Overview${seq.input}`]?.OverviewleadShow ===
                'Select Block' &&
                !input?.[`Overview${seq.input}`]?.Overviewnavigate ? (
                // Render select tag for Select Block
                <Select
                  placeholder={'Blocks...'}
                  id="Dialog"
                  name={`Overview${seq.input}`}
                  menuPortalTarget={document.body}
                  styles={customStyles}
                  options={showSelectBlock.filter(
                    (option: any) => option.value !== seq.input,
                  )}
                  isSearchable={true}
                  className="react-select"
                  value={
                    showSelectBlock.find(
                      (option: any) =>
                        option.value ==
                        input?.[`Overview${seq.input}`]?.Overviewnavigate,
                    ) || null
                  }
                  onChange={(e: any) =>
                    handleSelectBlock(
                      e,
                      seq.input,
                      `Overview${seq.input}`,
                      `Overview${seq.input}`,
                    )
                  }
                />
              ) : (
                // Render content for the 'else' condition
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <StrightConector
                      name={
                        input?.[`Overview${seq.input}`]?.OverviewleadShow ===
                          'New Block'
                          ? showSelectBlock.find(
                            (option: any) =>
                              option.value ==
                              input?.[`Overview${seq.input}`]?.Overviewnavigate,
                          )?.label
                          : input?.[`Overview${seq.input}`]?.OverviewleadShow ===
                            'Select Block'
                            ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`Overview${seq.input}`]?.Overviewnavigate,
                            )?.label
                            : input?.[`Overview${seq.input}`]?.Overviewnavigate
                      }
                    />
                  </div>
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default OverviewCompo;
